import { CnMessage } from '@alife/cn-ui';
import { request } from '@alife/cn-request';
import {
  getLowcodePageDetail,
  getLowcodePageUser,
  createAppGetBizAccessKey,
  syncConeDict,
  getCurrentAppInfo,
  findBusinessDomain,
} from 'src/const';
import { getEntityType } from './const';

/**
 * 获取cnpd产品列表
 * @param {*}
 */
const getCnpdProductList = async () => {
  const { data } = await request(findBusinessDomain);

  const list =
    data.data.map(({ id, name, children }) => {
      return {
        label: name,
        value: id,
        children: children?.map(({ id: childId, name: childName }) => {
          return { label: childName, value: childId };
        }),
      };
    }) || [];
  // 补充其它
  list.push({ label: '其它', value: 'other' });
  return list;
};

/**
 * 根据cnpdId匹配产品名
 * @param {*} cnpdDomainList 全量产品列表，两级暂不需递归
 * @param {*} cnpdId
 * @returns 产品名
 */
const findCnpdName = (cnpdDomainList, cnpdId) => {
  let cnpdParentData = null;
  let cnpdChildData = null;
  cnpdDomainList.forEach((item) => {
    if (item.children) {
      item.children.forEach((m) => {
        if (m.value === cnpdId) {
          cnpdParentData = item;
          cnpdChildData = m;
        }
      });
    } else if (item.value === cnpdId) {
      cnpdChildData = item;
    }
  });
  return {
    parent: cnpdParentData,
    child: cnpdChildData,
  };
};

/**
 * 弹出成功message
 * @param {*}
 */
const msgSuccess = ({ text, link }) => {
  CnMessage.success({
    type: 'success',
    content: (
      <span>
        {text}
        <a
          target='_blank'
          href={link?.url}
          style={{ color: '#284cc0' }}
          rel='noreferrer'
        >
          {link?.text}
        </a>
      </span>
    ),
    duration: 5000,
  });
};

/**
 * 弹出失败message
 * @param {*}
 */
const msgError = ({ text, link }) => {
  CnMessage.error({
    type: 'error',
    content: (
      <span>
        {text}
        <a
          target='_blank'
          href={link?.url}
          style={{ color: '#284cc0' }}
          rel='noreferrer'
        >
          {link?.text}
        </a>
      </span>
    ),
    duration: 6000,
  });
};

/**
 * 创建flamingo应用
 * @doc https://alidocs.dingtalk.com/i/nodes/a9E05BDRVQRkezKGC3PQvB60J63zgkYA?corpId=dingd8e1123006514592&utm_medium=im_card&iframeQuery=utm_medium%3Dportal_space_home2_trends%26utm_source%3Dportal&dontjump=true&utm_scene=team_space&utm_source=im&cid=395169078%3A568967214&cid=32401061%3A395169078
 * @returns
 */
export const createAppAndGetBizAccessKey = async () => {
  const {
    appName,

    // siteId,
    siteName,
    pageId,
    appCode,
    // siteAppCode,
    // siteAppPath,
    // pageRoute,
    // appDomain,
    // previewUrl,
    // gateWay,
    name,
    // pageType,
    // pageSubtype,
    // model = {},
    // canEdit = true,
    // enableGlobalJS,
    // siteTransfer = false,
    // datasetVersion,
    pageVersionId,
  } = getLowcodePageDetail();

  const { name: operatorName, workid: operatorId } = getLowcodePageUser();

  const { businessDomain } = getCurrentAppInfo(); // 获取当前页面所属产品id
  const cnpdList = await getCnpdProductList(); // 获取cnpd产品列表
  const { parent, child } = findCnpdName(cnpdList, businessDomain); // 根据当前页面产品id，获取主子产品详细信息

  const { data: res = {} } = await request({
    url: createAppGetBizAccessKey,
    method: 'POST',
    data: {
      /**
       * 应用名称
       */
      appName: siteName || appName,
      /**
       * 应用描述
       */
      appComment: `${siteName}站点页面：${name}`,
      /**
       * 所属产品线
       */
      productLineName: parent?.label || '',
      /**
       * 所属产品线Id
       */
      productLineId: parent?.value || '',
      /**
       * 所属产品
       */
      productName: child?.label || '',
      /**
       * 所属产品Id
       */
      productId: child?.value || '',
      /**
       * 所属页面名称
       */
      pageName: name,
      coneL2AppCode: appCode,
      coneL2PageId: pageId,
      coneL2PageVersionId: pageVersionId,
      operatorName,
      operatorId,
    },
  });
  const { success, data } = res;
  if (success) {
    msgSuccess({
      text: '已为您自动创建算法应用，',
      link: {
        text: '去查看',
        url: `https://flamingo.cainiao-inc.com/ams/workSpace/application/oneSearchBoxDetails?bizAccessKey=${data}`,
      },
    });
    return data;
  } else {
    msgError({
      text: '创建算法应用失败，',
      link: {
        text: '前往手动注册',
        url: `https://flamingo.cainiao-inc.com/ams/workSpace/application/oneSearchBox`,
      },
    });
  }
};

/**
 * 同步词典到flamingo
 * @doc https://alidocs.dingtalk.com/i/nodes/a9E05BDRVQRkezKGC3PQvB60J63zgkYA?corpId=dingd8e1123006514592&utm_medium=im_card&iframeQuery=utm_medium%3Dportal_space_home2_trends%26utm_source%3Dportal&dontjump=true&utm_scene=team_space&utm_source=im&cid=395169078%3A568967214&cid=32401061%3A395169078
 * @param {*}
 * @returns
 */
export const asyncDictToFlamingo = async ({ bizAccessKey, columnList }) => {
  const { name: operatorName, workid: operatorId } = getLowcodePageUser();

  const { data = {} } = await request({
    url: syncConeDict,
    method: 'POST',
    data: {
      bizAccessKey,
      coneColumnList: processColumnList(columnList),
      operatorName,
      operatorId,
    },
  });
  const { success } = data;
  if (success) {
    msgSuccess({
      text: '词典已同步，',
      link: {
        text: '去查看',
        url: `https://flamingo.cainiao-inc.com/ams/workSpace/application/oneSearchBoxDetails?bizAccessKey=${bizAccessKey}`,
      },
    });
  } else {
    msgError({
      text: '词典同步失败，',
      link: {
        text: '前往手动注同步',
        url: `https://flamingo.cainiao-inc.com/ams/workSpace/application/oneSearchBoxDetails?bizAccessKey=${bizAccessKey}`,
      },
    });
  }
  return data;
};

/**
 * cnFilter的config转换为flamingo要求的字典格式
 * @param {*} columnList
 * @returns
 */
const processColumnList = (columnList) =>
  columnList?.map((item) => {
    const { label, name, options, componentName, tip } = item;
    return {
      /**
       * 字段在前端展示的名字，即用户使用自然语言时查询使用的字段名
       */
      entityChineseKey: label?.dm,

      /**
       * 根据接入方式的不同，entityKey的内容也不同。 1. 如果是前端方式的接入，业务不感知算法接口，则该信息是老页面前端传给业务后端的字段名 2.
       * 如果是业务直接调用算法，该信息即字段对应的数据库字段名，可以直接使用查询数据库
       */
      entityKey: name,

      /**
       * 字段的业务含义描述
       */
      fieldDescription: tip?.dm || '',

      /**
       * 静态枚举
       * 字段的枚举值和数据库值的映射，key是界面上显示的枚举值，value是数据库中存储的值。 如果字段不需要context，词典内容使用enumDicts
       */
      enumDicts:
        options?.dataOrigin === 'static'
          ? options?.dataSource?.map((val) => {
              return {
                key: val.label?.dm,
                value: val.value,
              };
            })
          : [],

      /**
       * 动态枚举url
       */
      enumUrl:
        options?.dataOrigin === 'request'
          ? {
              url: options?.requestConfig?.url,
              httpMethod: options?.requestConfig?.method,
              contentType: options?.requestConfig?.contentType,
            }
          : {},

      /**
       * 前端对应的组件类型，具体可参考接入手册中的描述
       */
      entityType: getEntityType(componentName),

      /**
       * 时间字段数据需要返回的格式。只有当前字段为时间类型的字段是才需要传输
       */
      timeFormat: options?.outputFormat || '',

      /**
       * 分析型场景使用，字段所属的分析类型， 如果没有，默认是filter。如果同时属于多种分析类型，以逗号(,)分割
       * 具体取值参考https://alidocs.dingtalk.com/i/nodes/lyQod3RxJKe9QjOMialp66z2Wkb4Mw9
       */
      analyzeType: 'filter',

      /**
       * 当前字段属于哪种语言， 默认是中文（zh-CN）
       * 具体语言对应的字符串为下述文档里的语种标识。
       * https://alidocs.dingtalk.com/i/nodes/MNDoBb60VLYDGNPyt31gKD0EJlemrZQ3?cid=568967214%3A3905900841&utm_source=im&utm_scene=team_space&iframeQuery=utm_medium%3Dim_card%26utm_source%3Dim&utm_medium=im_card&dontjump=true&corpId=dingd8e1123006514592
       */
      languageCode: 'zh-CN',
    };
  });
